import { channel, SearchFilters, TmaEModule } from "@tm/models"
import { concat, TmaHelper, mapSourceIdToTmaModule, mapExternalVehicleIdentificationDto, checkTruckModule } from "@tm/utils"

import { PostMessageOptions } from "."
import { mapShowPartsListByTextToRequestArticleList } from "../business"

import { shouldUseNewModal } from "./helpers/newPartslist"

export function handleOpenOeAftermarket({ props, data }: PostMessageOptions) {
    const { oeNumber, altOeNumber, manufacturerIds, manufacturerId, vinNumber, vehicleIdentification } = data.openOeAftermarket ?? {}

    if (!oeNumber) {
        return
    }

    const request = mapShowPartsListByTextToRequestArticleList(
        concat(";", oeNumber, altOeNumber),
        manufacturerIds ?? (manufacturerId ? [manufacturerId] : undefined),
        props.oeAftermarketSearchFilter || SearchFilters.OeReference
    )

    const origin = mapSourceIdToTmaModule(TmaEModule.TRUCKVIN, data.sourceId)

    const { excludeWorkTaskVehicle, vehicleIdentificationDto } = mapExternalVehicleIdentificationDto(
        checkTruckModule(data.sourceId),
        vehicleIdentification,
        vinNumber,
        request.direct?.oeManufacturerIds?.first()
    )

    TmaHelper.ArticleListFiltered.ArticleListFiltered.Search.SubmitExternal(request.direct?.query, origin, {
        excludeWorkTaskVehicle,
        vehicleIdentification: vehicleIdentificationDto,
    })

    request.skipTma = true
    request.useNewModal = shouldUseNewModal(data.sourceId)

    channel("WORKTASK").publish("PARTS/REQUEST_LIST", request)
}
